import { FaMoneyBillWave } from "react-icons/fa";
import { GiTwoCoins, GiCoins, GiPayMoney, GiMoneyStack } from "react-icons/gi";
import {
    RiMoneyDollarCircleLine,
    RiMoneyEuroCircleLine,
    RiMoneyPoundCircleLine,
} from "react-icons/ri";
import { BsCurrencyYen, BsCurrencyBitcoin, BsCoin } from "react-icons/bs";

export type StripeCurrency = {
    currency: string;
    code: string;
    icon: React.ReactNode;
};

export const STRIPE_CURRENCIES = [
    {
        currency: "United States Dollar",
        code: "USD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Afghan Afghani", code: "AFN", icon: <GiTwoCoins /> },
    { currency: "Albanian Lek", code: "ALL", icon: <BsCoin /> },
    { currency: "Algerian Dinar", code: "DZD", icon: <GiCoins /> },
    { currency: "Angolan Kwanza", code: "AOA", icon: <GiTwoCoins /> },
    { currency: "Argentine Peso", code: "ARS", icon: <GiPayMoney /> },
    { currency: "Armenian Dram", code: "AMD", icon: <GiCoins /> },
    { currency: "Aruban Florin", code: "AWG", icon: <GiTwoCoins /> },
    {
        currency: "Australian Dollar",
        code: "AUD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Azerbaijani Manat", code: "AZN", icon: <GiMoneyStack /> },
    {
        currency: "Bahamian Dollar",
        code: "BSD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Bangladeshi Taka", code: "BDT", icon: <GiTwoCoins /> },
    {
        currency: "Barbadian Dollar",
        code: "BBD",
        icon: <RiMoneyDollarCircleLine />,
    },
    {
        currency: "Belize Dollar",
        code: "BZD",
        icon: <RiMoneyDollarCircleLine />,
    },
    {
        currency: "Bermudian Dollar",
        code: "BMD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Bolivian Boliviano", code: "BOB", icon: <GiCoins /> },
    {
        currency: "Bosnia & Herzegovina Convertible Mark",
        code: "BAM",
        icon: <GiTwoCoins />,
    },
    { currency: "Botswana Pula", code: "BWP", icon: <GiMoneyStack /> },
    { currency: "Brazilian Real", code: "BRL", icon: <FaMoneyBillWave /> },
    {
        currency: "British Pound",
        code: "GBP",
        icon: <RiMoneyPoundCircleLine />,
    },
    {
        currency: "Brunei Dollar",
        code: "BND",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Bulgarian Lev", code: "BGN", icon: <GiTwoCoins /> },
    { currency: "Burundian Franc", code: "BIF", icon: <GiCoins /> },
    { currency: "Cambodian Riel", code: "KHR", icon: <GiTwoCoins /> },
    {
        currency: "Canadian Dollar",
        code: "CAD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Cape Verdean Escudo", code: "CVE", icon: <GiTwoCoins /> },
    {
        currency: "Cayman Islands Dollar",
        code: "KYD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Central African Cfa Franc", code: "XAF", icon: <GiCoins /> },
    { currency: "Cfp Franc", code: "XPF", icon: <GiCoins /> },
    { currency: "Chilean Peso", code: "CLP", icon: <GiPayMoney /> },
    { currency: "Chinese Renminbi Yuan", code: "CNY", icon: <GiTwoCoins /> },
    { currency: "Colombian Peso", code: "COP", icon: <GiPayMoney /> },
    { currency: "Comorian Franc", code: "KMF", icon: <GiCoins /> },
    { currency: "Congolese Franc", code: "CDF", icon: <GiCoins /> },
    { currency: "Costa Rican Colón", code: "CRC", icon: <GiTwoCoins /> },
    { currency: "Croatian Kuna", code: "HRK", icon: <GiCoins /> },
    { currency: "Czech Koruna", code: "CZK", icon: <GiCoins /> },
    { currency: "Danish Krone", code: "DKK", icon: <GiTwoCoins /> },
    { currency: "Djiboutian Franc", code: "DJF", icon: <GiCoins /> },
    { currency: "Dominican Peso", code: "DOP", icon: <GiPayMoney /> },
    {
        currency: "East Caribbean Dollar",
        code: "XCD",
        icon: <RiMoneyDollarCircleLine />,
    },
    {
        currency: "Egyptian Pound",
        code: "EGP",
        icon: <RiMoneyPoundCircleLine />,
    },
    { currency: "Ethiopian Birr", code: "ETB", icon: <GiTwoCoins /> },
    { currency: "Euro", code: "EUR", icon: <RiMoneyEuroCircleLine /> },
    {
        currency: "Falkland Islands Pound",
        code: "FKP",
        icon: <RiMoneyPoundCircleLine />,
    },
    {
        currency: "Fijian Dollar",
        code: "FJD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Gambian Dalasi", code: "GMD", icon: <GiCoins /> },
    { currency: "Georgian Lari", code: "GEL", icon: <GiMoneyStack /> },
    {
        currency: "Gibraltar Pound",
        code: "GIP",
        icon: <RiMoneyPoundCircleLine />,
    },
    { currency: "Guatemalan Quetzal", code: "GTQ", icon: <GiCoins /> },
    { currency: "Guinean Franc", code: "GNF", icon: <GiCoins /> },
    {
        currency: "Guyanese Dollar",
        code: "GYD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Haitian Gourde", code: "HTG", icon: <GiTwoCoins /> },
    { currency: "Honduran Lempira", code: "HNL", icon: <GiTwoCoins /> },
    {
        currency: "Hong Kong Dollar",
        code: "HKD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Hungarian Forint", code: "HUF", icon: <GiCoins /> },
    { currency: "Icelandic Króna", code: "ISK", icon: <GiCoins /> },
    { currency: "Indian Rupee", code: "INR", icon: <GiTwoCoins /> },
    { currency: "Indonesian Rupiah", code: "IDR", icon: <GiMoneyStack /> },
    { currency: "Israeli New Sheqel", code: "ILS", icon: <GiTwoCoins /> },
    {
        currency: "Jamaican Dollar",
        code: "JMD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Japanese Yen", code: "JPY", icon: <BsCurrencyYen /> },
    { currency: "Kazakhstani Tenge", code: "KZT", icon: <GiTwoCoins /> },
    { currency: "Kenyan Shilling", code: "KES", icon: <GiCoins /> },
    { currency: "Kyrgyzstani Som", code: "KGS", icon: <GiCoins /> },
    { currency: "Lao Kip", code: "LAK", icon: <GiTwoCoins /> },
    {
        currency: "Lebanese Pound",
        code: "LBP",
        icon: <RiMoneyPoundCircleLine />,
    },
    { currency: "Lesotho Loti", code: "LSL", icon: <GiTwoCoins /> },
    {
        currency: "Liberian Dollar",
        code: "LRD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Macanese Pataca", code: "MOP", icon: <GiTwoCoins /> },
    { currency: "Macedonian Denar", code: "MKD", icon: <GiCoins /> },
    { currency: "Malagasy Ariary", code: "MGA", icon: <GiTwoCoins /> },
    { currency: "Malawian Kwacha", code: "MWK", icon: <GiCoins /> },
    { currency: "Malaysian Ringgit", code: "MYR", icon: <GiMoneyStack /> },
    { currency: "Maldivian Rufiyaa", code: "MVR", icon: <GiTwoCoins /> },
    { currency: "Mauritanian Ouguiya", code: "MRO", icon: <GiCoins /> },
    { currency: "Mauritian Rupee", code: "MUR", icon: <GiTwoCoins /> },
    { currency: "Mexican Peso", code: "MXN", icon: <GiPayMoney /> },
    { currency: "Moldovan Leu", code: "MDL", icon: <GiTwoCoins /> },
    { currency: "Mongolian Tögrög", code: "MNT", icon: <GiCoins /> },
    { currency: "Moroccan Dirham", code: "MAD", icon: <GiTwoCoins /> },
    { currency: "Mozambican Metical", code: "MZN", icon: <GiCoins /> },
    { currency: "Myanmar Kyat", code: "MMK", icon: <GiTwoCoins /> },
    {
        currency: "Namibian Dollar",
        code: "NAD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Nepalese Rupee", code: "NPR", icon: <GiTwoCoins /> },
    {
        currency: "Netherlands Antillean Gulden",
        code: "ANG",
        icon: <GiCoins />,
    },
    {
        currency: "New Taiwan Dollar",
        code: "TWD",
        icon: <RiMoneyDollarCircleLine />,
    },
    {
        currency: "New Zealand Dollar",
        code: "NZD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Nicaraguan Córdoba", code: "NIO", icon: <GiTwoCoins /> },
    { currency: "Nigerian Naira", code: "NGN", icon: <GiCoins /> },
    { currency: "Norwegian Krone", code: "NOK", icon: <GiTwoCoins /> },
    { currency: "Pakistani Rupee", code: "PKR", icon: <GiTwoCoins /> },
    { currency: "Panamanian Balboa", code: "PAB", icon: <GiCoins /> },
    { currency: "Papua New Guinean Kina", code: "PGK", icon: <GiTwoCoins /> },
    { currency: "Paraguayan Guaraní", code: "PYG", icon: <GiCoins /> },
    { currency: "Peruvian Nuevo Sol", code: "PEN", icon: <GiTwoCoins /> },
    { currency: "Philippine Peso", code: "PHP", icon: <GiPayMoney /> },
    { currency: "Polish Złoty", code: "PLN", icon: <GiTwoCoins /> },
    { currency: "Qatari Riyal", code: "QAR", icon: <GiCoins /> },
    { currency: "Romanian Leu", code: "RON", icon: <GiTwoCoins /> },
    { currency: "Russian Ruble", code: "RUB", icon: <GiCoins /> },
    { currency: "Rwandan Franc", code: "RWF", icon: <GiCoins /> },
    { currency: "São Tomé and Príncipe Dobra", code: "STD", icon: <GiCoins /> },
    {
        currency: "Saint Helenian Pound",
        code: "SHP",
        icon: <RiMoneyPoundCircleLine />,
    },
    { currency: "Salvadoran Colón", code: "SVC", icon: <GiTwoCoins /> },
    { currency: "Samoan Tala", code: "WST", icon: <GiTwoCoins /> },
    { currency: "Saudi Riyal", code: "SAR", icon: <GiCoins /> },
    { currency: "Serbian Dinar", code: "RSD", icon: <GiCoins /> },
    { currency: "Seychellois Rupee", code: "SCR", icon: <GiTwoCoins /> },
    { currency: "Sierra Leonean Leone", code: "SLL", icon: <GiCoins /> },
    {
        currency: "Singapore Dollar",
        code: "SGD",
        icon: <RiMoneyDollarCircleLine />,
    },
    {
        currency: "Solomon Islands Dollar",
        code: "SBD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Somali Shilling", code: "SOS", icon: <GiCoins /> },
    { currency: "South African Rand", code: "ZAR", icon: <GiTwoCoins /> },
    { currency: "South Korean Won", code: "KRW", icon: <GiCoins /> },
    { currency: "Sri Lankan Rupee", code: "LKR", icon: <GiTwoCoins /> },
    {
        currency: "Surinamese Dollar",
        code: "SRD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Swazi Lilangeni", code: "SZL", icon: <GiTwoCoins /> },
    { currency: "Swedish Krona", code: "SEK", icon: <GiTwoCoins /> },
    { currency: "Swiss Franc", code: "CHF", icon: <GiCoins /> },
    { currency: "Tajikistani Somoni", code: "TJS", icon: <GiTwoCoins /> },
    { currency: "Tanzanian Shilling", code: "TZS", icon: <GiCoins /> },
    { currency: "Thai Baht", code: "THB", icon: <GiTwoCoins /> },
    { currency: "Tongan Paʻanga", code: "TOP", icon: <GiCoins /> },
    {
        currency: "Trinidad and Tobago Dollar",
        code: "TTD",
        icon: <RiMoneyDollarCircleLine />,
    },
    { currency: "Turkish Lira", code: "TRY", icon: <GiCoins /> },
    { currency: "Ugandan Shilling", code: "UGX", icon: <GiCoins /> },
    { currency: "Ukrainian Hryvnia", code: "UAH", icon: <GiTwoCoins /> },
    { currency: "United Arab Emirates Dirham", code: "AED", icon: <GiCoins /> },
    { currency: "Uruguayan Peso", code: "UYU", icon: <GiPayMoney /> },
    { currency: "Uzbekistani Som", code: "UZS", icon: <GiCoins /> },
    { currency: "Vanuatu Vatu", code: "VUV", icon: <GiCoins /> },
    { currency: "Vietnamese Đồng", code: "VND", icon: <GiTwoCoins /> },
    { currency: "West African Cfa Franc", code: "XOF", icon: <GiCoins /> },
    { currency: "Yemeni Rial", code: "YER", icon: <GiCoins /> },
    { currency: "Zambian Kwacha", code: "ZMW", icon: <GiCoins /> },
];

export const DEFAULT_CURRENCY: StripeCurrency = STRIPE_CURRENCIES.find(
    (c) => c.code === "USD",
)!;
